import React from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import category from "../Assets/images/blog/category.jpg";
import second_row_pic from "../Assets/images/blog/second_row_pic.jpg";
import all_image1 from "../Assets/images/all_image1.jpeg";
import all_image2 from "../Assets/images/all_image2.jpeg";
import all_image3 from "../Assets/images/all_image3.jpeg";
import all_image4 from "../Assets/images/all_image4.jpeg";
import all_image5 from "../Assets/images/all_image5.jpeg";
import all_image6 from "../Assets/images/all_image6.jpeg";
import { Link } from 'react-router-dom';

const Portfolio = () => {
    return (
        <div className="portfolio_page">
            <div className="banner_section">
                <div className="container-layout">
                    <div className="blog_heading">
                        <h1>PortFolio</h1>
                        <ul className="breadcrumb">
                            <li><a href="/">Home</a></li>
                            <li>PortFolio</li>
                        </ul>

                    </div>

                    <div className="top-sec">
                        <div className="coustom_container">
                            <div className="heading">
                                <span className="m-0">Company Name</span>
                                <div className="">
                                    <h4 className="m-0">Company History</h4>
                                    <p className="m-0">
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel illum recusandae quaerat dignissimos dicta quisquam ea sit quo quia doloremque esse magnam atque fuga, a, maxime dolores architecto aperiam maiores.
                                    </p>

                                    <p className="m-0">
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel illum recusandae quaerat dignissimos dicta quisquam ea sit quo quia doloremque esse magnam atque fuga, a, maxime dolores architecto aperiam maiores.
                                    </p>

                                    <p className="m-0">
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel illum recusandae quaerat dignissimos dicta quisquam ea sit quo quia doloremque esse magnam atque fuga, a, maxime dolores architecto aperiam maiores.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="work_Sec">
                <div className="container-layout">
                    <p className='text-center primary_text'>MY PORTFOLIO</p>
                    <h2 className='text-center'>Checkout My Work</h2>
                    <p className='text-center'>Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text.</p>

                    <div className="tab_system">
                        <Tabs>
                            <TabList>
                                <Tab>All</Tab>
                                <Tab>Design</Tab>
                                <Tab>Development</Tab>
                                <Tab>Branding</Tab>
                            </TabList>

                            <TabPanel>
                                <div className="row">
                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={all_image2} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={all_image3} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={all_image1} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={all_image5} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={all_image6} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={all_image4} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row">
                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={all_image1} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={all_image2} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={all_image3} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row">
                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={all_image1} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={all_image2} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={all_image3} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row">
                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={category} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={second_row_pic} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                        <Link to="https://gnisoftsolutions.com/" target='blank'>
                                            <div className='img_gallary'>
                                                <div className='img_div'>
                                                    <img src={category} alt="category_pic" />
                                                </div>

                                                <div className='middle'>
                                                    <h6>PROJECT NAME</h6>
                                                    <p>Design/Branding</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Portfolio